export default __webpack_public_path__ + "static/media/bhphoto+orange.e81dfa9e.jpg";